module.exports = __webpack_public_path__ + "assets/img/sukikamolist.420df891.svg";